export default "__VITE_ASSET__CB$dFzsH__"